
import React from 'react';
import { Control } from 'react-hook-form';
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { RegistrationFormValues } from '@/schemas/registrationSchema';
import { User } from 'lucide-react';

interface BasicInfoFieldsProps {
  control: Control<RegistrationFormValues>;
}

// Function to validate name (at least 3 characters)
const validateName = (name: string): boolean => {
  return name.trim().length >= 3;
};

const BasicInfoFields: React.FC<BasicInfoFieldsProps> = ({ control }) => {
  return (
    <FormField
      control={control}
      name="fullName"
      render={({ field, fieldState }) => (
        <FormItem>
          <FormLabel className="flex items-center gap-2">
            <User size={16} className="text-blue-500" />
            Họ và tên <span className="text-red-500 font-bold">*</span>
          </FormLabel>
          <FormControl>
            <Input 
              placeholder="Nhập họ và tên đầy đủ" 
              {...field} 
              onChange={(e) => {
                field.onChange(e);
                // Add visual validation feedback during typing
                const isValid = validateName(e.target.value);
                e.target.classList.toggle('border-amber-300', e.target.value && !isValid);
                e.target.classList.toggle('border-green-400', e.target.value && isValid);
              }}
              aria-invalid={fieldState.invalid}
              aria-required="true"
              className={`transition-colors duration-200 ${
                fieldState.invalid 
                  ? 'border-red-500 focus:ring-red-500 focus:border-red-500 animate-shake' 
                  : field.value 
                    ? validateName(field.value) 
                      ? 'border-green-400 focus:ring-green-500 focus:border-green-500' 
                      : 'border-amber-300 focus:ring-amber-500 focus:border-amber-500' 
                    : 'focus:ring-blue-500 focus:border-blue-500'
              }`}
              required
            />
          </FormControl>
          <FormMessage className="text-red-500 animate-in fade-in-50 duration-200 text-xs md:text-sm mt-1" />
          {!fieldState.invalid && field.value && !validateName(field.value) && (
            <div className="text-amber-500 text-xs md:text-sm mt-1 animate-in fade-in-50 duration-200">
              Tên nên có ít nhất 3 ký tự
            </div>
          )}
          {!field.value && (
            <div className="text-amber-500 text-xs md:text-sm mt-1 animate-in fade-in-50 duration-200">
              Trường này là bắt buộc
            </div>
          )}
        </FormItem>
      )}
    />
  );
};

export default BasicInfoFields;
